/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLineAxisArrowDown: {
  name: 'line-axis-arrow-down';
  data: string;
} = {
  name: 'line-axis-arrow-down',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3a1 1 0 0 1 1 1v9.861l2.025-1.692a2 2 0 0 1 2.565 0l2.926 2.445 4.74-5.282a1 1 0 1 1 1.488 1.336l-4.74 5.282a2 2 0 0 1-2.77.198l-2.926-2.445L5 16.468V19h15a1 1 0 1 1 0 2H5a2 2 0 0 1-2-2V4a1 1 0 0 1 1-1Zm8 0a1 1 0 0 1 1 1v3.586l1.293-1.293a1 1 0 1 1 1.414 1.414l-3 3a1 1 0 0 1-1.414 0l-3-3a1 1 0 1 1 1.414-1.414L11 7.586V4a1 1 0 0 1 1-1Z" fill="currentColor"/></svg>`,
};
